define("media/utils/feature-requirements", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  const FeatureRequirements = [{
    name: 'Auto Publish',
    requiresUserToken: false,
    requiresOwnerToken: true,
    requiresBasicToken: false,
    AccountOwnerRequirements: ['instagram_content_publish'],
    TeamMemberUserToken: ['instagram_content_publish']
  }, {
    name: 'Visual Instagram Planner',
    requiresUserToken: false,
    requiresOwnerToken: true,
    requiresBasicToken: true,
    basicRequirements: ['instagram_graph_user_media'],
    AccountOwnerRequirements: ['instagram_basic', 'pages_read_engagement', 'pages_show_list'],
    TeamMemberUserToken: ['ads_management', 'pages_read_engagement', 'business_management']
  }, {
    name: 'Linkin.bio',
    requiresUserToken: true,
    requiresOwnerToken: false,
    requiresBasicToken: true,
    basicRequirements: ['instagram_graph_user_media'],
    AccountOwnerRequirements: ['instagram_basic', 'pages_read_engagement', 'pages_show_list'],
    TeamMemberUserToken: ['instagram_content_publish', 'ads_management', 'pages_read_engagement', 'business_management']
  }, {
    name: 'Conversations',
    requiresUserToken: true,
    requiresOwnerToken: false,
    requiresBasicToken: false,
    basicRequirements: [],
    AccountOwnerRequirements: ['instagram_basic', 'pages_show_list', 'pages_read_engagement'],
    TeamMemberUserToken: ['ads_management', 'pages_read_engagement', 'business_management']
  }, {
    name: 'Hashtags',
    requiresUserToken: true,
    requiresOwnerToken: false,
    requiresBasicToken: false,
    set: 'Collect',
    basicRequirements: [],
    AccountOwnerRequirements: ['instagram_basic', 'instagram_manage_comments', 'pages_read_engagement', 'pages_show_list'],
    TeamMemberUserToken: ['ads_management', 'pages_read_engagement', 'business_management']
  }, {
    name: 'Mentions',
    requiresUserToken: true,
    requiresOwnerToken: false,
    requiresBasicToken: false,
    set: 'Collect',
    basicRequirements: [],
    AccountOwnerRequirements: ['instagram_basic', 'instagram_manage_comments', 'pages_read_engagement', 'pages_show_list'],
    TeamMemberUserToken: ['ads_management', 'pages_read_engagement', 'business_management']
  }, {
    name: 'Analytics',
    requiresUserToken: false,
    requiresOwnerToken: true,
    requiresBasicToken: true,
    basicRequirements: [],
    AccountOwnerRequirements: ['instagram_basic', 'instagram_manage_insights', 'pages_read_engagement', 'pages_show_list'],
    TeamMemberUserToken: ['ads_management', 'business_management']
  }, {
    name: 'Partnerships',
    requiresUserToken: false,
    requiresOwnerToken: true,
    requiresBasicToken: false,
    basicRequirements: [],
    AccountOwnerRequirements: ['instagram_basic', 'instagram_manage_insights', 'pages_read_engagement', 'pages_show_list'],
    TeamMemberUserToken: ['ads_management', 'business_management']
  }];
  var _default = FeatureRequirements;
  _exports.default = _default;
});